// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__Oqfng","gfeWrapper":"CalendarEvent_gfeWrapper__iFrKt"};